
import React, {
  useState,
  useEffect,
  useCallback,
  updateState,
  useReducer,
  useContext,

} from "react";
import getUrl from "../function/getUrl.js"
import FunBarClass from "./funBarClass.js";
import { Link, useParams } from "react-router-dom";
import getDay from "../function/getDay.js"

import checkLogin from "../function/checkLogin.js"



//體驗追蹤記錄編輯
const Edit = () => {
  //銷售後 要同步調整 學員身分別
  // 體驗銷售 不得銷售給 正式學員
  //非本人時且權限為1時，不得更改密碼
  checkLogin()
  let param = useParams(); //功能項目
  let studentDBID = param.studentDBID;
  let followDBID = param.followDBID;
  console.log("studentDBID", studentDBID)
  const url = getUrl()
  const today = getDay(0, "-")
  const token = sessionStorage.getItem("token")
  const [studentData, setStudentData] = useState({})
  const [followData , setFollowData] = useState([])
  const operator = sessionStorage.getItem("staffDBID")

  const followInitial = {
    contact: "",
    contactType: "電話",
    createDate: "2025-07-27 17:19:40.771832",
    date:   new Date().toISOString().split('T')[0],
    idstudentTrialFollowDBID: followDBID,
    nextStep: "",
    note: "",
    operator: operator,
    result: "",
    studentDBID: studentDBID,
    updateDate: "",
    followDBID: followDBID,
  }

  const reduer=(state,action)=>{
    switch(action.type){
      case "contact":
        return {...state,contact:action.value}
      case "contactType":
        return {...state,contactType:action.value}
      case "date":
        return {...state,date:action.value} 
      case "nextStep":
        return {...state,nextStep:action.value}
      case "result":
        return {...state,result:action.value}
      case "reset":
        return followInitial
      default:
        return state
    }
  }

  const [state,dispatch]=useReducer(reduer,followInitial)



  const fetchStudentData = async (studentDBID) => {
    return fetch(`${url}/appGet/singleStudentView?studentDBID=${studentDBID}&token=${token}`).then((res) => {
      return res.json()
    }).then((json) => {
      //設置 student Data
      return json
      console.log(json)
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }

  const fetchStudentLastDate=async (studentDBID)=>{
    return fetch(`${url}/appGet/getStudentLastDate?studentDBID=${studentDBID}&token=${token}`).then((res) => {
      return res.json()
    }).then((json) => {
      
      console.log(json)
      if (json[0]==null){
        return ""
      }
      return json[0].lastDate
      
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }

 const fetchFollowData = async (followDBID) => {
    return fetch(`${url}/appGet/getStudentTrialFollow?studentDBID=${studentDBID}&token=${token}`).then((res) => {
      return res.json()
    }).catch((e) => {
      alert('伺服器錯誤')
    })
  }

  
  useEffect(() => {

    
    const setStudent = async (studentDBID) => {
      let student = await fetchStudentData(studentDBID)
      let studentLastDate= await fetchStudentLastDate(studentDBID)
      let follows= await fetchFollowData(followDBID)
      console.log("follows",follows)
      setFollowData(follows.find(item=>item.idstudentTrialFollowDBID==followDBID))
      console.log(studentLastDate)
      document.getElementById('title').innerHTML = `新增 ${student.name} 體驗追蹤記錄`
      document.getElementById('name').innerHTML = student.name
      document.getElementById('nickName').innerHTML = student.nickName
      document.getElementById('parent').innerHTML = student.parent
      document.getElementById('date').value = today



    }
    setStudent(studentDBID)
  
  }, [])

  useEffect(() => {
    if (followData) {
      dispatch({ type: "reset" })
      dispatch({ type: "contact", value: followData.contact })
      dispatch({ type: "contactType", value: followData.contactType })
      dispatch({ type: "date", value: followData.date })
      dispatch({ type: "nextStep", value: followData.nextStep })
      dispatch({ type: "result", value: followData.result })
    }
    console.log("followData",followData)
  }, [followData])

  function handelSummit() {
    

      var formData = new FormData();
      formData.append("followDBID", state.followDBID);
      formData.append("studentDBID", state.studentDBID);
      formData.append("date", state.date);
      formData.append("contactType", state.contactType);
      formData.append("contact", state.contact);
      formData.append("nextStep", state.nextStep);
      formData.append("token", token);
      formData.append("operator",state.operator);

      console.log("formData", ...formData)
      fetch(`${url}/appPost/updateStudentTrialFollow`, {
        method: "POST",
        body: formData,
        mode: "cors",
      })
        .then((res) => {
          return res.json()

        }).then(() => {
          window.location.href = `/SingleStudentTrialView/${studentDBID}`
        })

    
  }

const handelDelete=()=>{
  if (window.confirm("確定刪除？")){
    var formData = new FormData();
    formData.append("followDBID", state.followDBID);
    formData.append("token", token);  
    console.log("formData", ...formData)
    fetch(`${url}/appPost/deleteStudentTrialFollow`, {
      method: "POST",
      body: formData,
      mode: "cors",
    })
      .then((res) => {
        return res.json()   
      }).then(() => {
        window.location.href = `/SingleStudentTrialView/${studentDBID}`
      })
  }
}


  return (
    <>

      <div className="container vw-100 " style={{ maxWidth: "500px" }}>
        <div className="card bg-info text-white p-2 flex flex-row justify-content-between align-items-center" style={{ width: "100%" }}>
          <h5 className="m-1" id="title">新增 {studentData.name} 體驗追蹤記錄</h5>
          <button
            className="btn btn-danger text-white"
            onClick={handelDelete}
          >刪除</button>
        </div>
        <div className="mt-2">
          <div className="card mt-2 ">
            <div className="card-header alert-info">基本資料區</div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    姓名
                      </span>
                </div>
                <div

                  id="name"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                />
              </div>
            </div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    暱稱
                      </span>
                </div>
                <div

                  id="nickName"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                />
              </div>
            </div>

            <div className="m-1">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-info"
                    id="validationTooltipUsernamePrepend"
                  >
                    家長
                      </span>
                </div>
                <div

                  id="parent"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"

                />
              </div>
            </div>


          </div>

          <div className="card  mt-2 " style={{ width: "100%" }}>
            <div className="card-header alert-warning">追蹤記錄資料區</div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    追蹤日期
                      </span>
                </div>
                <input
                  type="date"
                  id="date"
                  className="form-control"
                  aria-describedby="validationTooltipUsernamePrepend"
                  required
                 
                  value={state.date}
                  onChange={(e)=>{
                    dispatch({type:"date", value:e.target.value})
                  }}
                />
              </div>
            </div>

            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    連絡方式
                      </span>
                </div>
                <select id="contactType" className="custom-select" required  onChange={(e)=>{
                  dispatch({type:"contactType", value:e.target.value})
                }}
                value={state.contactType}
                >
                    <option value="電話">電話</option>
                    <option value="Line">Line</option>
                    <option value="FB">FB</option>
                    <option value="其他">其他</option>

                </select>
              </div>
            </div>


            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    連絡內容
                      </span>
                </div>
                <textarea
                  
                  id="contact"
                  cols="50" rows="3"
                  className="form-control"
                  value={state.contact}
                  aria-describedby="validationTooltipUsernamePrepend"
                  onChange={(e)=>{
                    dispatch({type:"contact", value:e.target.value})
                  }}
               
                />

              </div>
            </div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    連絡結果
                      </span>
                </div>
                <textarea
                  
                  id="result"
                  cols="50" rows="3"
                  className="form-control"
                 value={state.result}
                  aria-describedby="validationTooltipUsernamePrepend"
                  onChange={(e)=>{
                    dispatch({type:"result", value:e.target.value})
                  }}
                />

              </div>
            </div>
            <div className="m-1 ">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text alert-warning"
                    id="validationTooltipUsernamePrepend"
                  >
                    狀態
                      </span>
                </div>
                <select id="nextStep" className="custom-select" required onChange={(e)=>{
                  dispatch({type:"nextStep", value:e.target.value})
                }} value={state.nextStep}>
                  <option value="待追蹤">待追蹤</option>
                  <option value="已聯絡待回覆">已聯絡待回覆</option>
                  <option value="已確定時段待匯款">已確定時段待匯款</option>
                  <option value="已匯款">已匯款</option>
                  <option value="因特殊狀況取消">因特殊狀況取消</option>
                  <option value="考慮中-課程時間">考慮中-課程時間</option>
                  <option value="考慮中-預算問題+會籍壓力">考慮中-預算問題+會籍壓力</option>
                  <option value="考慮中-交通地點便利性">考慮中-交通地點便利性</option>
                  <option value="考慮中-其他">考慮中-其他</option>
                  <option value="不考慮-時間配合不上">不考慮-時間配合不上</option>
                  <option value="不考慮-課程費用+會籍壓力">不考慮-課程費用+會籍壓力</option>
                  <option value="不考慮-太遠/交通不便">不考慮-太遠/交通不便</option>
                  <option value="不考慮-其他">不考慮-其他</option>
                  <option value="結案">結案</option>
                </select>
              </div>
            </div>
           
          </div>

         

          <div className="card  mt-2 p-1" style={{ width: "100%" }}>
            <button
              type="button"
              onClick={handelSummit}
              className="btn btn-danger "
            >
              更新記錄
                </button>
            <Link to={`/SingleStudentView/${studentDBID}`}>
              <div
                className="btn alert-dark mt-1" style={{ width: "100%" }}
              >
                取消
                  </div>
            </Link>
          </div>

        </div>
      </div>
    </>
  )

};



export default Edit;